<template>
  <v-row justify="center">
    <SnackBar ref="snackbar" />
    <v-dialog
      v-model="dialog"
      v-if="ativo && this.equipeMembros.length"
      persistent
      width="680"
    >
      <v-card v-click-outside="onClickOutside">
        <v-card-title>
          <span class="text-h5">Avaliar Equipe</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="d-flex justify-end">
              <span style="font-size: 12px">
                Pontos disponíveis: {{ pontos_liberados }}
              </span>
            </div>
            <div class="d-flex justify-end">
              <span style="font-size: 12px">
                Pontos usados: {{ pontos_usados }}
              </span>
            </div>
            <div
              v-for="n in equipeMembros.length"
              :key="n"
              cols="12"
              sm="8"
              md="12"
            >
              <span class="label">{{ equipeMembros[n - 1].nomeEqui }}</span>
              <br />
              <v-text-field
                v-model.number="pontos[n - 1]"
                variant="underlined"
                label="Pontos*"
                type="number"
                @input="calcularPontosUsados"
                style="display: inline-block; width: 15%; margin-right: 10px"
              ></v-text-field>
              <v-text-field
                v-model="comentarios[n - 1]"
                variant="underlined"
                label="Comentário"
                style="display: inline-block; width: 75%"
                :maxlength="255"
                @input="comentarioTamanho"
              ></v-text-field>
              <p style="display: inline-block; width: 5%; font-size: 10px">
                {{ tamCom[n - 1] }}
              </p>
            </div>
          </v-container>
          <small>*Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark variant="text" @click="fechar">
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            dark
            variant="text"
            @click="registerRating"
          >
            Responder Avaliação
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

export default {
  props: {
    // eslint-disable-next-line camelcase, vue/prop-name-casing
    id_avaliacao: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line camelcase, vue/prop-name-casing
    id_projeto: {
      type: Number,
      default: null,
    },
    ativo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SnackBar,
  },
  created() {
    this.fetchEquipe();
  },
  data: () => ({
    dialog: true,
    pontos: [],
    tamCom: [],
    comentarios: [],
    equipeMembros: [],
    // eslint-disable-next-line camelcase
    pontos_usados: 0,
    // eslint-disable-next-line camelcase
    pontos_liberados: 0,
    // eslint-disable-next-line camelcase
    id_equipe: null,
  }),
  methods: {
    enviarSolicitacaoParaPai() {
      this.$emit('solicitacaoFechar', { solicitacao: false });
    },
    fechar() {
      this.enviarSolicitacaoParaPai();
      this.pontos = [];
      this.comentarios = [];
      this.equipeMembros = [];
      // eslint-disable-next-line camelcase
      this.pontos_liberados = 0;
      // eslint-disable-next-line camelcase
      this.pontos_usados = 0;
    },
    comentarioTamanho() {
      for (let i = 0; i < this.comentarios.length; i++) {
        this.tamCom[i] = 255 - this.comentarios[i].length;
      }
    },
    fetchEquipe() {
      axios
        .get(`${API_URL}/projetos/listaprojeto/${this.id_projeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((resp) => {
          // eslint-disable-next-line camelcase
          this.id_equipe = parseInt(resp.data.id_equipe_fk);
          console.log('projeto', resp.data);
          console.log(this.id_projeto);
          axios
            .get(`${API_URL}/equipes/${this.id_equipe}`, {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            })
            .then((response) => {
              response.data.forEach((equi) => {
                this.tamCom.push(255);
                if (
                  store.state.idUsuario != equi.id_usuario &&
                  equi.forma_atuacao != 'SCRUM_MASTER'
                ) {
                  this.equipeMembros.push({
                    nomeEqui: equi.nome,
                    idUsuario: equi.id_usuario,
                    formaAtuacao: equi.forma_atuacao,
                  });
                }
              });
              if (!this.equipeMembros.length) {
                this.$refs.snackbar.showWarningSnackbar(
                  'Atenção!',
                  'Todos os membros dessa equipe, diferentes de você, não são desenvolvedores',
                );
              }
              // eslint-disable-next-line camelcase
              this.pontos_liberados = this.equipeMembros.length * 10;
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error('erro', error);
        });
    },
    calcularPontosUsados() {
      let totalPontosUsados = 0;
      for (let i = 0; i < this.pontos.length; i++) {
        if (isNaN(this.pontos[i]) || this.pontos[i] < 0) {
          this.pontos[i] = 0;
        } else {
          totalPontosUsados += parseInt(this.pontos[i]) || 0;
        }
      }
      // eslint-disable-next-line camelcase
      this.pontos_usados = totalPontosUsados;
    },
    registerRating() {
      let pontos = this.pontos;
      let comentarios = this.comentarios;
      // eslint-disable-next-line camelcase
      let id_avaliacao = this.id_avaliacao;
      // eslint-disable-next-line camelcase
      let avaliacao = [];
      if (this.pontos_usados > this.pontos_liberados) {
        this.$refs.snackbar.showWarningSnackbar(
          'Atenção!',
          `Você está usando mais pontos que o permitido.\n${
            this.pontos_usados - this.pontos_liberados
          } pontos a mais que o permitido.`,
        );
      } else {
        avaliacao = this.equipeMembros.map(function (membro, index) {
          var comentario =
            comentarios[index] === undefined ? '' : comentarios[index];

          return {
            // eslint-disable-next-line camelcase
            id_usuario_avaliado: membro.idUsuario,
            pontos: parseInt(pontos[index]), // eslint-disable-line
            // eslint-disable-next-line camelcase
            id_avaliacao: id_avaliacao,
            comentario: comentario,
          };
        });
        const data = {
          avaliacoes: avaliacao,
        };
        console.log('Dados:', data);
        axios
          .post(API_URL + `/avaliacaoIndividual/${this.id_projeto}`, data, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Avaliação realizada com sucesso!',
            );
            this.dialog = false;
            this.pontos = [];
            this.comentarios = [];
            this.equipeMembros = [];
            // eslint-disable-next-line camelcase
            this.pontos_liberados = 0;
            // eslint-disable-next-line camelcase
            this.pontos_usados = 0;
            location.reload();
          })
          .catch((error) => {
            console.log('Dados:', data);
            console.log(error.response.data.error);
            this.$refs.snackbar.showErrorSnackbar(
              'Hm... Algo deu errado',
              'Por algum motivo, não conseguimos realizar sua avaliação!',
            );
          });
      }
    },
    onClickOutside() {
      this.enviarSolicitacaoParaPai();
    },
  },
};
</script>

<style>
.label {
  font-size: 18px;
}
.campo-pequeno {
  width: 200px;
}
.inline-block {
  display: inline-block;
}
.my-border {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
